<template>
  <div class="mb-4">
    <h1 class="h1">{{ trans('auth.login.title') }}</h1>
    <p class="py-1">{{ trans('auth.login.intro') }}</p>
  </div>

  <form @submit.prevent="submit">
    <form-input
      id="email-field"
      container-class="form-group"
      type="email"
      name="email"
      v-model="form.email"
      :error="form.errors.email"
      :labelText="trans('common.email')"
      :placeholder="trans('common.email')"
      autofocus
    />

    <form-input
      id="password-field"
      container-class="form-group"
      type="password"
      name="password"
      v-model="form.password"
      :error="form.errors.password"
      :labelText="trans('common.password')"
      :placeholder="trans('common.password')">
      <inertia-link :href="localeRoute('password.request')" class="float-right" v-text="trans('auth.login.forgot_password')"/>
    </form-input>

    <template v-if="requiresAccept">
      <div class="form_row form_group mb-0">
        <form-input id="terms"
                    type="checkbox"
                    v-model="form.terms"
                    :error="form.errors.terms"
                    :label-text="trans('auth.accept_terms_of_service')"/>
      </div>
      <div class="form_row form_group mt-0">
        <form-input id="processing_agreement"
                    type="checkbox"
                    v-model="form.processing_agreement"
                    :error="form.errors.processing_agreement"
                    :label-text="trans('auth.accept_processing_agreement')"/>
      </div>
    </template>

    <!-- Remember Me -->
    <div class="form_row">
      <form-input
        id="remember-me"
        type="checkbox"
        name="remember"
        v-model="form.remember"
        :error="form.errors.remember"
        :labelText="trans('auth.login.remember_me')"
      />

      <form-button :value="trans('auth.login.title')" :processing="form.processing"/>
    </div>

    <div class="flex justify-content-between align-items-center mt-4 pt-4 border-top">
      <div>
        {{ trans('auth.login.no_account') }}
        <inertia-link class="btn btn-link font_bold" :href="localeRoute('register')" v-text="trans('auth.register.title')"/>
      </div>

      <language-toggle :route-to="{ name: 'login' }"/>
    </div>
  </form>
</template>

<script>
import AuthLayout from '@/Layouts/AuthLayout';

export default {
  layout: AuthLayout,
};
</script>

<script setup>
import {useLocales} from "@/composables/locales";
import {useForm} from '@inertiajs/vue3';
import LanguageToggle from '@/components/Shared/LanguageToggle';
import FormInput from '@/components/Shared/Form/Input/Index';
import FormButton from '@/components/Shared/Form/Button';

const props = defineProps({
  status: String,
  ccvAppStore: String,
  requiresAccept: Boolean,
});

const localeRoute = useLocales().localeRoute

const form = useForm({
  email: null,
  password: null,
  terms: false,
  processing_agreement: false,
  remember: false,
});

const submit = () => {
  form
    .transform(data => ({
      ...data,
      remember: data.remember ? 'on' : '',
      ccv_app_store: props.ccvAppStore,
      requires_accept: props.requiresAccept,
    }))
    .post(localeRoute('login.store'), {
      onFinish: () => form.reset('password'),
    });
};
</script>
